import { Middleware } from '@reduxjs/toolkit'

export const conductorMiddleware: Middleware = (storeAPI) => (next) => (action: any) => {
  const result = next(action)
  return result
}
